// extracted by mini-css-extract-plugin
export default {"orderContainer":"orderdetails_orderContainer__MmQGA","orderSummaryRow":"orderdetails_orderSummaryRow__akJMf","orderBtn":"orderdetails_orderBtn__FpE6H"};